import "../styles/styles.scss";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer">Made with ❤️ and ☕ by Himanshu Aswal</div>
    </div>
  );
};
export default Footer;
